import { useEffect, useState } from 'react';
import { delayUntilIdle } from '../utils/delayUntilIdle';
export const useIsIdle = () => {
  const [isIdle, setIsIdle] = useState(false);
  useEffect(() => {
    return delayUntilIdle(() => setIsIdle(true));
  }, []);
  return isIdle;
};